import { ReactElement } from "react";
import { Checkbox } from "./Checkbox";

export type CenteredCheckboxProps = {
	value: boolean;
	trackingId?: string;
} & (
	{
		onChange(value: boolean): void;
		isDisabled?: false;
		shouldBubbleClick?: boolean;
	} | {
		isDisabled: true;
		onChange?: undefined;
		shouldBubbleClick?: undefined;
	}
);

export const CenteredCheckbox = (props: CenteredCheckboxProps): ReactElement => {
	const {
		value,
		onChange,
		isDisabled = false,
		shouldBubbleClick,
		trackingId
	} = props;

	return (
		<Checkbox
			value={value}
			onChange={onChange ?? NOOP}
			isDisabled={isDisabled}
			trackingId={trackingId}
			isCentered
			shouldBubbleClick={shouldBubbleClick}
		/>
	);
};
CenteredCheckbox.displayName = "CenteredCheckbox";

function NOOP(): void { /* NOOP */ }
